import { ReactComponent as ActiveActionsIcon } from 'assets/actionPlan/Dashboard/activeActions.svg';
import { ReactComponent as CompletionRateIcon } from 'assets/actionPlan/Dashboard/completionRate.svg';
import { ReactComponent as PendingReviewsIcon } from 'assets/actionPlan/Dashboard/pendingReviews.svg';
import { ReactComponent as TotalEmployessIcon } from 'assets/actionPlan/Dashboard/totalEmployess.svg';

export const DURATION_OPTIONS = [
  { value: 'DAILY', label: 'Daily' },
  { value: 'WEEKLY', label: 'Weekly' },
  { value: 'MONTHLY', label: 'Monthly' },
];
export const COMP_DETAILS = {
  belowLow: {
    label: 'Below Low Deduction (%)',
    subText: 'Applied when Actual < Low',
    type: 'danger',
  },
  lowToTarget: {
    label: 'Low to Target Deduction (%)',
    subText: 'Applied when Low ≤ Actual < Target',
    type: 'warning',
  },
  targetToHigh: {
    label: 'Target to High Bonus (%)',
    subText: 'Applied when Target ≤ Actual ≤ High',
    type: 'success',
  },
  aboveHigh: {
    label: 'Above High Bonus (%)',
    subText: 'Applied when Actual > High',
    type: 'info',
  },
};
export const ASSIGNEE_OPTIONS = [
  { value: 'EMPLOYEE', label: 'Employee' },
  { value: 'DEPARTMENT', label: 'Department' },
];
export const ESTIMATION_OPTIONS = [
  { value: 'QUANTITY', label: 'Quantity' },
  { value: 'FINANCIAL', label: 'Financial' },
  { value: 'BOTH', label: 'Both' },
];
export const DURATION_TYPE_OPTIONS = [
  { value: 'DAILY', label: 'Daily' },
  { value: 'WEEKLY', label: 'Weekly' },
  { value: 'MONTHLY', label: 'Monthly' },
];
export const ACTION_OPTIONS = [
  { value: 'PRIMARY', label: 'Primary' },
  { value: 'SECONDARY', label: 'Secondary' },
];
export const STATUS_OPTIONS = [
  { value: 'true', label: 'Active' },
  { value: 'false', label: 'Inactive' },
];
export const getBonusSteps = (data) => [
  {
    key: 'belowLowDeduction',
    type: 'deduction',
    title: 'Below Low Deduction (%)',
    value: data?.compensationConfig?.belowLowDeduction,
    prefix: '-',
    desc: 'Applied when Actual < Low',
  },
  {
    key: 'lowToTargetDeduction',
    type: 'warning',
    title: 'Low to Target Deduction (%)',
    value: data?.compensationConfig?.lowToTargetDeduction,
    prefix: '-',
    desc: 'Applied when Low ≤ Actual < Target',
  },
  {
    key: 'targetToHighBonus',
    type: 'bonus',
    title: 'Target to High Bonus (%)',
    value: data?.compensationConfig?.targetToHighBonus,
    prefix: '+',
    desc: 'Applied when Target ≤ Actual ≤ High',
  },
  {
    key: 'aboveHighBonus',
    type: 'extra',
    title: 'Above High Bonus (%)',
    value: data?.compensationConfig?.aboveHighBonus,
    prefix: '+',
    desc: 'Applied when Actual > High',
  },
];
export const getStatsConfig = (data) => [
  {
    label: 'Active Actions',
    value: data.activeActionsCount || 0,
    icon: ActiveActionsIcon,
    bgColor: 'linear-gradient(135deg, #EFF6FF 0%, #DBEAFE 100%)',
    borderColor: '#BEDBFF',
    iconBg: '#2B7FFF',
    labelColor: '#155DFC',
    valueColor: '#1C398E',
  },
  {
    label: 'Total Employees',
    value: data.totalEmployees || 0,
    icon: TotalEmployessIcon,
    bgColor: 'linear-gradient(135deg, #FFFFFF 0%, #FFDADB 100%)',
    borderColor: '#FF9AAE',
    iconBg: '#E63946',
    labelColor: '#E63946',
    valueColor: '#7E2A0C',
  },
  {
    label: 'Pending Reviews',
    value: data.pendingReviewsCount || 0,
    icon: PendingReviewsIcon,
    bgColor: 'linear-gradient(135deg, #FFF7ED 0%, #FFEDD4 100%)',
    borderColor: '#FFD6A8',
    iconBg: '#FF6900',
    labelColor: '#F54900',
    valueColor: '#7E2A0C',
  },
  {
    label: 'Completion Rate',
    value: `${data.completionRate || 0}%`,
    icon: CompletionRateIcon,
    bgColor: 'linear-gradient(135deg, #F0FDF4 0%, #DCFCE7 100%)',
    borderColor: '#B9F8CF',
    iconBg: '#15C7A7',
    labelColor: '#15C7A7',
    valueColor: '#0D542B',
  },
];

export const getActionListStatsConfig = (data) => [
  {
    label: 'TOTAL PLANNED',
    value: data.totalPlanned || 0,
    bgColor: 'linear-gradient(135deg, #EFF6FF 0%, #DBEAFE 100%)',
    iconBg: '#2B7FFF',
    borderColor: '#BEDBFF',
    labelColor: '#155DFC',
    valueColor: '#1C398E',
    icon: ActiveActionsIcon,
  },
  {
    label: 'TOTAL PRESENTED',
    value: data.totalPresented || 0,
    bgColor:
      'linear-gradient(135deg, rgba(243, 232, 255, 0.2) 0%, rgba(152, 16, 250, 0.2) 100%)',
    iconBg: '#9810FA',
    borderColor: '#F3E8FF',
    labelColor: '#9810FA',
    valueColor: '#540090',
    icon: CompletionRateIcon,
  },
  {
    label: 'TOTAL ACTUAL',
    value: data.totalActual || 0,
    bgColor: 'linear-gradient(135deg, #F0FDF4 0%, #DCFCE7 100%)',
    iconBg: '#15C7A7',
    borderColor: '#B9F8CF',
    labelColor: '#15C7A7',
    valueColor: '#0D542B',
    icon: CompletionRateIcon,
  },
];
